import React from "react";
import { View } from "react-native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { usePatient } from "@louise/patients/hooks/usePatient";
import { PregnancyProvider, getResumeRoute } from "./PregnancyContext";
import { PregnancyUsageScreen } from "./screens/PregnancyUsageScreen";
import { PregnancyDetailsScreen } from "./screens/PregnancyDetailsScreen";
import { PregnancyCompleteScreen } from "./screens/PregnancyCompleteScreen";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type PregnancyStackParamList = {
  PregnancyUsage: undefined;
  PregnancyDetails: undefined;
  PregnancyComplete: undefined;
};

const Stack = createNativeStackNavigator<PregnancyStackParamList>();

function PregnancyStack() {
  const { data: patient } = usePatient();
  const initialRoute = getResumeRoute(patient);

  return (
    <Stack.Navigator
      initialRouteName={initialRoute}
      screenOptions={{ headerShown: false }}
    >
      <Stack.Screen name="PregnancyUsage" component={PregnancyUsageScreen} />
      <Stack.Screen
        name="PregnancyDetails"
        component={PregnancyDetailsScreen}
      />
      <Stack.Screen
        name="PregnancyComplete"
        component={PregnancyCompleteScreen}
      />
    </Stack.Navigator>
  );
}

export function PregnancyNavigator() {
  const { data: patient, isLoading } = usePatient();

  // Wait for patient data so the provider can initialise state synchronously
  if (isLoading || !patient) {
    return <View style={{ flex: 1, backgroundColor: "#050B1D" }} />;
  }

  return (
    <PregnancyProvider>
      <MedicalHistoryQuestionProvider
        section="pregnancies"
        sectionLabelKey="med_history.review.section_title.pregnancies"
        helpTextKey="med_history.question_screen.flow_help.pregnancies"
      >
        <PregnancyStack />
      </MedicalHistoryQuestionProvider>
    </PregnancyProvider>
  );
}
